import { useJsApiLoader } from '@react-google-maps/api';

const GOOGLE_MAPS_LIBRARIES: ('places')[] = ['places'];

const useGoogleMapsLoader = () => useJsApiLoader({
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
  libraries: GOOGLE_MAPS_LIBRARIES,
});

export default useGoogleMapsLoader;
